import { Component, h, Host, Prop } from '@stencil/core';
import { InputVariant } from '../uui-input-utils';
import { SvgInHtml } from '../../uui-util/utils';

@Component({
  tag: 'uui-input-error',
  styleUrl: 'uui-input-error.css',
  shadow: true
})
export class UUIInputError {
  @Prop() width: string = '100%';
  @Prop() variant: InputVariant = 'error';
  @Prop({ mutable: true, reflect: true }) show: boolean = false;

  render() {
    const style = {
      width: this.width
    };

    if (!this.show) return null;

    const errorIcon = (
      <svg
        id="light-exclamation-triangle"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 576 512"
      >
        <path d="M270.2 160h35.5c3.4 0 6.1 2.8 6 6.2l-7.5 196c-.1 3.2-2.8 5.8-6 5.8h-20.5c-3.2 0-5.9-2.5-6-5.8l-7.5-196c-.1-3.4 2.6-6.2 6-6.2zM288 388c-15.5 0-28 12.5-28 28s12.5 28 28 28 28-12.5 28-28-12.5-28-28-28zm281.5 52L329.6 24c-18.4-32-64.7-32-83.2 0L6.5 440c-18.4 31.9 4.6 72 41.6 72H528c36.8 0 60-40 41.5-72zM528 480H48c-12.3 0-20-13.3-13.9-24l240-416c6.1-10.6 21.6-10.7 27.7 0l240 416c6.2 10.6-1.5 24-13.8 24z" />
      </svg>
    );

    const warningIcon = (
      <svg
        id="light-circle-exclamation"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
      >
        <path d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 480c-123.5 0-224-100.5-224-224s100.5-224 224-224s224 100.5 224 224S379.5 480 256 480zM256 304c8.844 0 16-7.156 16-16V128c0-8.844-7.156-16-16-16S240 119.2 240 128v160C240 296.8 247.2 304 256 304zM256 344c-13.25 0-24 10.75-24 24s10.75 24 24 24s24-10.75 24-24S269.3 344 256 344z" />
      </svg>
    );

    const iconMap: { [VARIANT in InputVariant]: SvgInHtml } = {
      error: errorIcon,
      warning: warningIcon
    };

    const icon: SvgInHtml = iconMap[this.variant] ?? errorIcon;

    return (
      <Host style={style}>
        <div data-mode={this.variant}>
          <div class="uui-input-error-icon">{icon}</div>
          <div class="uui-input-error-content">
            <slot />
          </div>
        </div>
      </Host>
    );
  }
}
